import { chartsMutationTypes } from './mutation-types';

export const mutations = {
  [chartsMutationTypes.FANBASE_GROWTH_TABLE_LOADING] (state, loading) {
    state.fanbaseGrowthTable.isLoading = loading;
  },
  [chartsMutationTypes.FANBASE_GROWTH_TABLE_ERROR] (state, error) {
    state.fanbaseGrowthTable.hasError = error;
  },
  [chartsMutationTypes.FANBASE_GROWTH_TABLE_DATA] (state, { data }) {
    state.fanbaseGrowthTable.data = data;
  },

  [chartsMutationTypes.FANBASE_EVOLUTION_LOADING] (state, loading) {
    state.fanbaseEvolution.isLoading = loading;
  },
  [chartsMutationTypes.FANBASE_EVOLUTION_ERROR] (state, error) {
    state.fanbaseEvolution.hasError = error;
  },
  [chartsMutationTypes.FANBASE_EVOLUTION_DATA] (state, { data }) {
    state.fanbaseEvolution.data = data;
  },
  [chartsMutationTypes.FANBASE_EVOLUTION_PERIOD] (state, periodSelected) {
    state.fanbaseEvolution.periodSelected = periodSelected;
  },

  [chartsMutationTypes.TOTAL_PUBLICATIONS_LOADING] (state, loading) {
    state.totalPublication.isLoading = loading;
  },
  [chartsMutationTypes.TOTAL_PUBLICATIONS_ERROR] (state, error) {
    state.totalPublication.hasError = error;
  },
  [chartsMutationTypes.TOTAL_PUBLICATIONS_DATA] (state, { series, categories }) {
    state.totalPublication.data.series = series;
    state.totalPublication.data.categories = categories;
  },

  [chartsMutationTypes.PUBLICATIONS_BY_MEDIA_TYPE_LOADING] (state, loading) {
    state.publicationByMediaType.isLoading = loading;
  },
  [chartsMutationTypes.PUBLICATIONS_BY_MEDIA_TYPE_ERROR] (state, error) {
    state.publicationByMediaType.hasError = error;
  },
  [chartsMutationTypes.PUBLICATIONS_BY_MEDIA_TYPE_DATA] (state, { series, categories }) {
    state.publicationByMediaType.data.series = series;
    state.publicationByMediaType.data.categories = categories;
  },

  [chartsMutationTypes.TOP_PUBLICATION_BY_CHANNEL_LOADING] (state, loading) {
    state.topPublicationByChannel.isLoading = loading;
  },
  [chartsMutationTypes.TOP_PUBLICATION_BY_CHANNEL_ERROR] (state, error) {
    state.topPublicationByChannel.hasError = error;
  },
  [chartsMutationTypes.TOP_PUBLICATION_BY_CHANNEL_DATA] (state, { data }) {
    state.topPublicationByChannel.data = data;
  },

  [chartsMutationTypes.INTERACTIONS_OVER_TIME_LOADING] (state, loading) {
    state.interactionsOverTime.isLoading = loading;
  },
  [chartsMutationTypes.INTERACTIONS_OVER_TIME_ERROR] (state, error) {
    state.interactionsOverTime.hasError = error;
  },
  [chartsMutationTypes.INTERACTIONS_OVER_TIME_DATA] (state, { data }) {
    state.interactionsOverTime.data = data;
  },
  [chartsMutationTypes.INTERACTIONS_OVER_TIME_PERIOD] (state, periodSelected) {
    state.interactionsOverTime.periodSelected = periodSelected;
  },

  [chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_LOADING] (state, loading) {
    state.interactionsAndEngagementRate.isLoading = loading;
  },
  [chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_ERROR] (state, error) {
    state.interactionsAndEngagementRate.hasError = error;
  },
  [chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_DATA] (state, { series, categories }) {
    state.interactionsAndEngagementRate.data.series = series;
    state.interactionsAndEngagementRate.data.categories = categories;
  },

  [chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_LOADING] (state, loading) {
    state.interactionsBySocialNetworkAndMediaType.isLoading = loading;
  },
  [chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_ERROR] (state, error) {
    state.interactionsBySocialNetworkAndMediaType.hasError = error;
  },
  [chartsMutationTypes.INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_DATA] (state, { series, categories }) {
    state.interactionsBySocialNetworkAndMediaType.data.series = series;
    state.interactionsBySocialNetworkAndMediaType.data.categories = categories;
  },

  [chartsMutationTypes.AVERAGE_INTERACTIONS_BY_PUBLICATION_LOADING] (state, loading) {
    state.averageInteractionsByPublication.isLoading = loading;
  },
  [chartsMutationTypes.AVERAGE_INTERACTIONS_BY_PUBLICATION_ERROR] (state, error) {
    state.averageInteractionsByPublication.hasError = error;
  },
  [chartsMutationTypes.AVERAGE_INTERACTIONS_BY_PUBLICATION_DATA] (state, { series, categories, metadata }) {
    state.averageInteractionsByPublication.data.series = series;
    state.averageInteractionsByPublication.data.categories = categories;
    state.averageInteractionsByPublication.data.metadata = metadata;
  },

  [chartsMutationTypes.ENGAGEMENT_OVER_TIME_LOADING] (state, loading) {
    state.engagementOverTime.isLoading = loading;
  },
  [chartsMutationTypes.ENGAGEMENT_OVER_TIME_ERROR] (state, error) {
    state.engagementOverTime.hasError = error;
  },
  [chartsMutationTypes.ENGAGEMENT_OVER_TIME_DATA] (state, { data }) {
    state.engagementOverTime.data = data;
  },
  [chartsMutationTypes.ENGAGEMENT_OVER_TIME_PERIOD] (state, periodSelected) {
    state.engagementOverTime.periodSelected = periodSelected;
  },

  [chartsMutationTypes.ENGAGEMENT_MATRIX_LOADING] (state, loading) {
    state.engagementMatrix.isLoading = loading;
  },
  [chartsMutationTypes.ENGAGEMENT_MATRIX_ERROR_DEFAULT] (state, error) {
    state.engagementMatrix.hasError.default = error;
  },
  [chartsMutationTypes.ENGAGEMENT_MATRIX_ERROR_PID_LIMIT] (state, error) {
    state.engagementMatrix.hasError.pidLimit = error;
  },
  [chartsMutationTypes.ENGAGEMENT_MATRIX_DATA] (state, { series, metadata }) {
    state.engagementMatrix.data.series = series;
    state.engagementMatrix.data.metadata = metadata;
  },

  [chartsMutationTypes.DISTRIBUTION_OF_INTERACTIONS_LOADING] (state, loading) {
    state.distributionOfInteractions.isLoading = loading;
  },
  [chartsMutationTypes.DISTRIBUTION_OF_INTERACTIONS_ERROR] (state, error) {
    state.distributionOfInteractions.hasError = error;
  },
  [chartsMutationTypes.DISTRIBUTION_OF_INTERACTIONS_DATA] (state, { series, categories }) {
    state.distributionOfInteractions.data.series = series;
    state.distributionOfInteractions.data.categories = categories;
  },

  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_LOADING] (state, loading) {
    state.sentimentsInTheComments.isLoading = loading;
  },
  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_ERROR] (state, error) {
    state.sentimentsInTheComments.hasError = error;
  },
  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_DATA] (state, { series, categories }) {
    state.sentimentsInTheComments.data.series = series;
    state.sentimentsInTheComments.data.categories = categories;
  },

  [chartsMutationTypes.TERMS_MENTIONED_LOADING] (state, loading) {
    state.termsMentioned.isLoading = loading;
  },
  [chartsMutationTypes.TERMS_MENTIONED_ERROR] (state, error) {
    state.termsMentioned.hasError = error;
  },
  [chartsMutationTypes.TERMS_MENTIONED_DATA] (state, { series }) {
    state.termsMentioned.data = series;
  },

  [chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_LOADING] (state, loading) {
    state.publicationsOverTimeWithDistribution.isLoading = loading;
  },
  [chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_ERROR] (state, error) {
    state.publicationsOverTimeWithDistribution.hasError = error;
  },
  [chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_DATA] (state, { series, categories }) {
    state.publicationsOverTimeWithDistribution.data.series = series;
    state.publicationsOverTimeWithDistribution.data.categories = categories;
  },
  [chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_PERIOD] (state, periodSelected) {
    state.publicationsOverTimeWithDistribution.periodSelected = periodSelected;
  },
  [chartsMutationTypes.PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_GROUP] (state, groupSelected) {
    state.publicationsOverTimeWithDistribution.groupSelected = groupSelected;
  },

  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_LOADING] (state, loading) {
    state.sentimentsInTheCommentsOverTime.isLoading = loading;
  },
  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_ERROR] (state, error) {
    state.sentimentsInTheCommentsOverTime.hasError = error;
  },
  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_DATA] (state, { data }) {
    state.sentimentsInTheCommentsOverTime.data = data;
  },
  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_PERIOD] (state, periodSelected) {
    state.sentimentsInTheCommentsOverTime.periodSelected = periodSelected;
  },
  [chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_GROUP] (state, groupSelected) {
    state.sentimentsInTheCommentsOverTime.groupSelected = groupSelected;
  },
};
